import { render, staticRenderFns } from "./Endpoints.vue?vue&type=template&id=57335bcd&scoped=true"
import script from "./Endpoints.vue?vue&type=script&lang=js"
export * from "./Endpoints.vue?vue&type=script&lang=js"
import style0 from "./Endpoints.vue?vue&type=style&index=0&id=57335bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57335bcd",
  null
  
)

export default component.exports